import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Subscription } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { CorrelationActionObserver } from './correlation-action-observer';
import { ActionWithCorrelationAttributes } from './correlation-actions';

@Injectable({
  providedIn: 'root'
})
export class CorrelationObserverService {

  constructor(
    private readonly actions$: Actions
  ) {
    this.actions$ = this.actions$.pipe(shareReplay());
    this.actions$.subscribe();
  }

  /**
   * Connect to CorrelationActionObserver and observe action
   * return a Subscription
   *
   * @param action
   * @param onSuccess
   * @param onError
   */
  public subscribeToAction(
    action: ActionWithCorrelationAttributes,
    onSuccess: () => void,
    onError?: () => void
    ): Subscription {
      const observer = new CorrelationActionObserver(this.actions$);
      return observer.subscribeToAction(action, onSuccess, onError);
  }
}
